import { useEffect } from 'react';
import { setDefaultOptions } from 'date-fns';

import { getShortLocale } from 'shared/utils/locale';
import { getDateLocale } from 'shared/utils/date';

import { useLanguageValue } from './useLanguage';

export function useSetDateFnsDefaults() {
  const language = useLanguageValue();

  useEffect(() => {
    setDefaultOptions({
      locale: getDateLocale(getShortLocale(language))
    });
  }, [language]);
}
